import * as PropTypes from 'prop-types';
export var propTypes = {
    links: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        href: PropTypes.string.isRequired,
        current: PropTypes.bool
    }).isRequired),
    homeLink: PropTypes.string,
    productInfo: PropTypes.shape({
        name: PropTypes.string.isRequired,
        version: PropTypes.string
    })
};
//# sourceMappingURL=types.js.map